import { useEffect } from 'react';

import { useRudderStack } from '@ocx-app/lib/rudderStack/useRudderStack';
import { ReplaceToHome } from '@ocx-app/pages/Home/ReplaceToHome';

import { useConfiguration } from '@ocx/data-configuration';

import { OrderAheadLayout } from './order-ahead.layout';
import { OrderAheadProviderVroom, OrderAheadProviderLula } from './providers';

export const OrderAheadController = () => {
  const {
    config: { orderAhead },
  } = useConfiguration();
  const { triggerEvent, triggerLocation } = useRudderStack();

  if (!orderAhead.enabled) {
    throw new Error('Order Ahead is disabled in config, but the controller was used. Please use the config guard.');
  }

  useEffect(() => {
    triggerLocation();
    triggerEvent('order_ahead_page_view');
    return () => triggerEvent('order_ahead_session_end');
  }, [triggerEvent, triggerLocation]);

  return (
    <OrderAheadLayout>
      {orderAhead.provider.type === 'vroom' && (
        <OrderAheadProviderVroom iframeUrlTemplate={orderAhead.provider.urlTemplate} />
      )}
      {orderAhead.provider.type === 'lula' && <OrderAheadProviderLula />}

      {/* Right now Olo is not supported via Iframe */}
      {/* Redirect to home page when direct link used */}
      {orderAhead.provider.type === 'olo' && <ReplaceToHome />}
      {/* {orderAhead.provider.type === 'olo' && <OrderAheadProviderOlo />} */}

      {/* Add other providers here as needed */}
    </OrderAheadLayout>
  );
};
